import BasicNode, { BasicNodeProps } from "./BasicNode";

const RunningNode = (props: BasicNodeProps) => (
  <BasicNode {...props} className="border-blue-500 bg-blue-100" />
);

export default RunningNode;
